import { PortSrc } from './PortSrc';

export enum PortVisitSrcActivity {
	Cruising = 'CRUISING',
	Debark = 'DEBARK',
	Docked = 'DOCKED',
	Embark = 'EMBARK',
	Tendered = 'TENDERED',
	Touring = 'TOURING',
}

export interface PortVisitSrc {
	port: PortSrc,
	activity: PortVisitSrcActivity,
	arrivalTime: string,
	departureTime: string,
}